import { makeApiTypes } from 'sidecar-utility-library'

export default {
  ...makeApiTypes('FETCH_SPECIALTY_SUGGESTIONS', 'suggestions/specialties'),
  ...makeApiTypes('FETCH_PROVIDER_SUGGESTIONS', 'suggestions/providers'),
  CLEAR_SUGGESTIONS: 'suggestions/CLEAR_SUGGESTIONS',
}
